export default "__VITE_ASSET__H7cGsLO9__"